import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatThreadDefaultVariants = {}
const chatThreadCompoundVariants = []

const chatThreadSlotNames = [
  [
    "root",
    "chatThread__root"
  ],
  [
    "viewport",
    "chatThread__viewport"
  ],
  [
    "viewportFooter",
    "chatThread__viewportFooter"
  ]
]
const chatThreadSlotFns = /* @__PURE__ */ chatThreadSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatThreadDefaultVariants, getSlotCompoundVariant(chatThreadCompoundVariants, slotName))])

const chatThreadFn = memo((props = {}) => {
  return Object.fromEntries(chatThreadSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatThreadVariantKeys = []
const getVariantProps = (variants) => ({ ...chatThreadDefaultVariants, ...compact(variants) })

export const chatThread = /* @__PURE__ */ Object.assign(chatThreadFn, {
  __recipe__: false,
  __name__: 'chatThread',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatThreadVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, chatThreadVariantKeys)
  },
  getVariantProps
})